export default __webpack_public_path__ + "images/fbfbd7ab84ad64723b9f3f052439f1b3-halloween_desktop.webp";